module.exports = __webpack_public_path__ + "static/media/grabaseat6.5fae84ba.jpg";